import { gql } from '@apollo/client';

const schema = {
  assignment: {
    name: 'setCouponProductShop',
    serviceName: 'unitadmin',
    query: gql`
      mutation setCouponProductShop($coupon_id: String!, $assignment_type: String, $product_category_ids: [String]) {
        setCouponProductShop(
          coupon_id: $coupon_id
          assignment_type: $assignment_type
          product_category_ids: $product_category_ids
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
